<div class="flex-fill d-flex flex-column">
    <div class="d-flex">
        <div class="column ms-2 me-2"><span class="color-legend submitted"></span> - Submitted</div>
        <div class="column ms-2 me-2"><span class="color-legend approved"></span> - Approved</div>
        <div class="column ms-2 me-2"><span class="color-legend paid"></span> - Paid</div>
    </div>
    <div class="m-1 grid-fill" *ngIf="expenseReports">
        <dx-data-grid
            #dataGrid
            [dataSource]="expenseReports"
            keyExpr="id"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onRowDblClick)="onRowDoubleClick($event)"
            (onRowPrepared)="onRowPrepared($event)"
        >
            <dxi-column dataField="expenseDate" caption="Date" width="100"></dxi-column>
            <dxi-column dataField="customer.companyName" caption="Customer" width="200"></dxi-column>
            <dxi-column dataField="invoice.invoiceNumber" caption="Work Order #" alignment="left" width="120"></dxi-column>
            <dxi-column dataField="_totalAmount" caption="Total" width="100" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
            <dxi-column dataField="submitted" width="100"></dxi-column>
            <dxi-column dataField="approved" width="100"></dxi-column>
            <dxi-column dataField="paid" width="100"></dxi-column>
            <dxi-column dataField="created" width="100"></dxi-column>
            <dxi-column dataField="createdBy" width="100"></dxi-column>
            <dxi-column></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-selection [mode]="'single'"></dxo-selection>
            <dxo-state-storing [enabled]="'true'" type="localStorage" storageKey="expense-report-overview-grid"></dxo-state-storing>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-secondary ms-2" (click)="open()">New</button>
                <button
                    class="btn btn-success ms-2"
                    (click)="open(dataGrid.instance.getSelectedRowsData()[0].id)"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Open
                </button>
                <button
                    class="btn btn-danger ms-2"
                    (click)="deleteExpense(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Delete
                </button>
                <button
                    class="btn btn-success ms-2"
                    (click)="markAsSubmitted(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Submit Expense Report
                </button>
                <button
                    class="btn btn-primary ms-4"
                    (click)="markAsApproved(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    *ngIf="isCreditAdmin"
                >
                    Approve
                </button>
                <button
                    class="btn btn-primary ms-1"
                    (click)="markAsPaid(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                    *ngIf="isCreditAdmin"
                >
                    Mark As Paid
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="expenseReports" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
